<template>
  <div>
    <v-card flat class="doviz-filtre mb-2">
      <v-layout row wrap align-center>
        <v-flex xs12 sm3 md2 class="px-3 py-2">
          <div class="doviz-baslik">Döviz</div>
        </v-flex>
        <v-flex xs12 sm5 md6 class="px-3 py-2">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Ara"
            single-line
            hide-details
            @keyup.enter="initialize"
          ></v-text-field>
        </v-flex>
        <v-flex xs8 sm3 md3 class="px-3 py-2">
          <v-select
            v-model="select"
            :items="items"
            item-value="id"
            item-text="value"
            return-object
            hide-details
            label="Aktif / Pasif"
          ></v-select>
        </v-flex>
        <v-flex xs4 sm1 md1 class="px-3 py-2 text-xs-right">
          <v-btn color="primary" dark @click="initialize" class="ma-0">Ara</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <div class="doviz-tablo">
    <v-data-table
      :headers="headers"
      :loading="this.$store.state.progress"
      :rows-per-page-items="pageItems"
      :items="this.$store.state.priceIncrease.all"
      :pagination.sync="pagination"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            class="px-0 text-xs-center"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
            ]"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <td class="px-0 text-xs-center">{{ props.item.id }}</td>
        <td class="px-0 text-xs-center">{{ props.item.price }}</td>
        <td class="px-0 text-xs-center">
          {{ props.item.startDate | formatDate }}
        </td>
        <td class="px-0 text-xs-center">
          {{ props.item.endDate | formatDate }}
        </td>
        <td class="px-0 text-xs-center">{{ props.item.startTime }}</td>
        <td class="px-0 text-xs-center">{{ props.item.endTime }}</td>
        <td class="px-0 text-xs-center" v-if="props.item.state == 1">Aktif</td>
        <td class="px-0 text-xs-center" v-else>Pasif</td>
        <td class="px-0 text-xs-center urun-hucre">
          <v-tooltip bottom v-if="props.item.productIds" max-width="460">
            <template v-slot:activator="{ on }">
              <div class="urun-kutu" v-on="on">
                <span class="urun-rozet">{{ urunAdedi(props.item.productIds) }}</span>
                <span class="urun-metin">{{ urunMetni(props.item.productIds) }}</span>
              </div>
            </template>
            <div class="urun-ipucu">
              <div class="urun-ipucu-baslik">{{ urunAdedi(props.item.productIds) }}</div>
              <div class="urun-ipucu-liste">{{ urunMetni(props.item.productIds) }}</div>
            </div>
          </v-tooltip>
          <span v-else class="grey--text">-</span>
        </td>

        <td class="px-0 text-xs-center son-islem-hucre" v-if="logYetkisi">
          <div v-if="sonIslem(props.item.id)" class="son-islem-kutu">
            <div class="son-islem-ad">{{ sonIslem(props.item.id).kullanici }}</div>
            <div class="son-islem-alt">
              {{ sonIslem(props.item.id).islem }} · {{ sonIslem(props.item.id).tarih | formatDate }}
            </div>
          </div>
          <span v-else class="grey--text">-</span>
        </td>

        <td class="px-0 text-xs-center">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small class="mr-2" @click="deleteItem(props.item)">delete</v-icon>
          <v-icon v-if="logYetkisi" small @click="gecmisiAc(props.item)">history</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
    </div>

    <v-dialog v-model="gecmisDialog" max-width="900" scrollable>
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>
            Döviz İşlem Geçmişi
            <span v-if="gecmisKayit" class="subheading"> · Id {{ gecmisKayit.id }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="gecmisDialog = false"><v-icon>close</v-icon></v-btn>
        </v-toolbar>

        <div class="gecmis-filtre">
          <div class="gecmis-filtre-sol">
            <v-btn small flat :class="{ 'aralik-aktif': aralik === 1 }" @click="aralikSec(1)">1 Ay</v-btn>
            <v-btn small flat :class="{ 'aralik-aktif': aralik === 3 }" @click="aralikSec(3)">3 Ay</v-btn>
            <v-btn small flat :class="{ 'aralik-aktif': aralik === 0 }" @click="aralikSec(0)">Tümü</v-btn>
            <span class="gecmis-tarih-alan">
              <input type="date" v-model="baslangic" class="gecmis-tarih" @change="aralik = -1" />
              <span class="mx-1 grey--text">–</span>
              <input type="date" v-model="bitis" class="gecmis-tarih" @change="aralik = -1" />
              <v-btn small color="primary" class="ml-2 my-0" @click="gecmisiYukle">Uygula</v-btn>
            </span>
            <span class="gecmis-arama-alan">
              <input
                type="text"
                v-model="fiyatArama"
                class="gecmis-arama"
                placeholder="Fiyat ara (örn. -85)"
              />
              <v-icon small v-if="fiyatArama" class="ml-1" @click="fiyatArama = ''">close</v-icon>
            </span>
          </div>
          <div class="gecmis-sayac" v-if="gecmisOzet.toplamKayit">
            <span v-if="fiyatArama">
              <strong>{{ filtreliGecmis.length }}</strong> eşleşme ·
              aralıkta {{ gecmisOzet.gosterilenKayit }} kayıt ·
            </span>
            <span v-else>
              <strong>{{ gecmisOzet.gosterilenKayit }}</strong> kayıt gösteriliyor ·
            </span>
            toplam <strong>{{ gecmisOzet.toplamKayit }}</strong>
            <span v-if="gecmisOzet.ilkKayitTarihi" class="grey--text">
              (ilk kayıt {{ gecmisOzet.ilkKayitTarihi | formatDate }})
            </span>
          </div>
        </div>

        <v-card-text style="max-height: 60vh">
          <div v-if="gecmisYukleniyor" class="text-xs-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>

          <div v-else-if="fiyatArama && !filtreliGecmis.length" class="text-xs-center grey--text py-4">
            <div>"{{ fiyatArama }}" için bu aralıkta eşleşme yok.</div>
            <div class="caption">
              Aralıkta {{ gecmis.length }} kayıt var.
              <span v-if="aralik !== 0">Daha geniş aramak için "Tümü" seçebilirsiniz.</span>
            </div>
          </div>

          <div v-else-if="!gecmis.length" class="text-xs-center grey--text py-4">
            <div v-if="gecmisOzet.toplamKayit">
              Seçilen tarih aralığında kayıt yok.
              <div class="caption">
                Bu kuralın toplam {{ gecmisOzet.toplamKayit }} kaydı var, "Tümü" ile hepsini görebilirsiniz.
              </div>
            </div>
            <div v-else>Bu döviz kaydı için işlem geçmişi bulunmuyor.</div>
          </div>

          <div v-else>
            <div
              v-for="kayit in filtreliGecmis"
              :key="kayit.id"
              class="gecmis-satir"
              :style="{ borderLeftColor: islemRengiKod(kayit.islem) }"
            >
              <div class="mb-1">
                <strong>{{ kayit.kullanici }}</strong>
                <span class="grey--text"> · {{ kayit.tarih | formatDate }}</span>
                <v-chip small :color="islemRengi(kayit.islem)" text-color="white" class="ml-2">
                  {{ kayit.islem }}
                </v-chip>
              </div>

              <div v-if="kayit.eskiTutar !== null || kayit.yeniTutar !== null" class="mb-1">
                Tutar:
                <span v-if="kayit.eskiTutar !== null">{{ kayit.eskiTutar }}</span>
                <span v-if="kayit.eskiTutar !== null && kayit.yeniTutar !== null"> → </span>
                <strong v-if="kayit.yeniTutar !== null">{{ kayit.yeniTutar }}</strong>
              </div>

              <div v-if="kayit.eklenenUrunler.length" class="mb-1">
                <span class="green--text">Eklenen ürünler ({{ kayit.eklenenUrunler.length }}):</span>
                <div class="caption">
                  <span v-for="(u, i) in kayit.eklenenUrunler" :key="'e' + u.productId">
                    {{ u.ad }}<span v-if="u.sku"> ({{ u.sku }})</span><span v-if="i < kayit.eklenenUrunler.length - 1">, </span>
                  </span>
                </div>
              </div>

              <div v-if="kayit.cikarilanUrunler.length" class="mb-1">
                <span class="red--text">Çıkarılan ürünler ({{ kayit.cikarilanUrunler.length }}):</span>
                <div class="caption">
                  <span v-for="(u, i) in kayit.cikarilanUrunler" :key="'c' + u.productId">
                    {{ u.ad }}<span v-if="u.sku"> ({{ u.sku }})</span><span v-if="i < kayit.cikarilanUrunler.length - 1">, </span>
                  </span>
                </div>
              </div>

              <div v-if="kayit.digerDegisiklikler.length" class="caption grey--text">
                <div v-for="(d, i) in kayit.digerDegisiklikler" :key="'d' + i">{{ d }}</div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import priceIncreaseApi from "@/api/priceIncrease";
import { authenticationService } from "@/_services";

export default {
  data: () => ({
    pagination: {
      sortBy: "name",
    },
    select: { id: -1, value: "Tümü" },
    search: null,
    pageItems: [
      25,
      50,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
    ],
    items: [
      { id: -1, value: "Tümü" },
      { id: false, value: "Pasif" },
      { id: true, value: "Aktif" },
    ],
    gecmisDialog: false,
    gecmisKayit: null,
    gecmis: [],
    gecmisYukleniyor: false,
    gecmisOzet: {},
    fiyatArama: "",
    aralik: 1,
    baslangic: null,
    bitis: null,
    sonIslemler: [],
    temelBasliklar: [
      {
        text: "Id",
        align: "left",
        value: "id",
      },
      { text: "Fiyat", value: "price" },
      { text: "Başlangıç Tarihi", value: "startDate" },
      { text: "Bitiş Tarihi", value: "endDate" },
      { text: "Başlangıç Saati", value: "startTime" },
      { text: "Bitiş Saati", value: "endTime" },
      { text: "Durum", value: "state" },
      { text: "Ürünler", value: "productIds" },
        
    ],
  }),
  computed: {
    logYetkisi() {
      const u = authenticationService.currentUserValue;
      return !!(u && u.canViewPriceIncreaseLogs);
    },
    filtreliGecmis() {
      const q = (this.fiyatArama || "").trim().replace(",", ".");
      if (!q) return this.gecmis;

      const sayi = Number(q);
      if (q === "-" || q === "." || isNaN(sayi)) return this.gecmis;

      const esit = (v) => v !== null && v !== undefined && Number(v) === sayi;
      return this.gecmis.filter((k) => esit(k.eskiTutar) || esit(k.yeniTutar));
    },
    headers() {
      const h = [...this.temelBasliklar];
      if (this.logYetkisi) h.push({ text: "Son İşlem", value: "sonIslem", sortable: false });
      h.push({ text: "İşlem", value: "name", sortable: false });
      return h;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    //this.initialize();
  },

  methods: {
    async initialize() {
      await this.$store.dispatch("priceIncrease/searchPriceIncrease", {
        search: this.search,
        state: this.select.id,
      });
      await this.sonIslemleriYukle();
    },
    async sonIslemleriYukle() {
      if (!this.logYetkisi) return;
      try {
        const yanit = await priceIncreaseApi.getSonIslemler();
        this.sonIslemler = yanit.data || [];
      } catch (e) {
        this.sonIslemler = [];
      }
    },
    urunMetni(productIds) {
      if (!productIds) return "";
      return productIds
        .split(",")
        .map((x) => x.trim())
        .filter((x) => x)
        .join(", ");
    },
    urunAdedi(productIds) {
      if (!productIds) return "0 ürün";
      return productIds.split(",").filter((x) => x.trim()).length + " ürün";
    },
    sonIslem(id) {
      return this.sonIslemler.find((x) => x.priceIncreaseId === id) || null;
    },
    async gecmisiAc(item) {
      this.gecmisKayit = item;
      this.gecmis = [];
      this.gecmisOzet = {};
      this.fiyatArama = "";
      this.gecmisDialog = true;
      this.aralikSec(1);
    },
    aralikSec(ay) {
      this.aralik = ay;
      if (ay === 0) {
        this.baslangic = null;
        this.bitis = null;
      } else {
        const b = new Date();
        b.setMonth(b.getMonth() - ay);
        this.baslangic = this.tariheCevir(b);
        this.bitis = this.tariheCevir(new Date());
      }
      this.gecmisiYukle();
    },
    tariheCevir(d) {
      const ay = String(d.getMonth() + 1).padStart(2, "0");
      const gun = String(d.getDate()).padStart(2, "0");
      return `${d.getFullYear()}-${ay}-${gun}`;
    },
    async gecmisiYukle() {
      if (!this.gecmisKayit) return;
      this.gecmisYukleniyor = true;
      try {
        const yanit = await priceIncreaseApi.getGecmis(
          this.gecmisKayit.id,
          this.baslangic,
          this.bitis
        );
        const d = yanit.data || {};
        this.gecmis = d.kayitlar || [];
        this.gecmisOzet = d;
      } catch (e) {
        this.gecmis = [];
        this.gecmisOzet = {};
      } finally {
        this.gecmisYukleniyor = false;
      }
    },
    islemRengiKod(islem) {
      if (islem === "Ekleme") return "#43a047";
      if (islem === "Silme") return "#e53935";
      if (islem === "Güncelleme") return "#fb8c00";
      return "#9e9e9e";
    },
    islemRengi(islem) {
      if (islem === "Ekleme") return "green";
      if (islem === "Silme") return "red";
      if (islem === "Güncelleme") return "orange";
      return "grey";
    },
    editItem(item) {
      this.$router.push({
        name: "priceIncrease-detail",
        params: { id: item.id },
      });
    },

    deleteItem(item) {
      confirm("Silmek İstediğinizden Emin Misiniz?") &&
        this.$store.dispatch("priceIncrease/deletePriceIncrease", item);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
  },
  async mounted() {
    await this.initialize();
  },
};
</script>

<style scoped>
.doviz-filtre {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.doviz-baslik {
  font-size: 20px;
  font-weight: 500;
  color: #37474f;
}
.doviz-tablo {
  max-width: 100%;
  overflow-x: auto;
}
.doviz-tablo >>> table {
  table-layout: fixed;
  width: 100%;
}
.doviz-tablo >>> th,
.doviz-tablo >>> td {
  padding: 0 6px !important;
}

.urun-hucre {
  max-width: 260px;
}
.urun-kutu {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
}
.urun-rozet {
  flex: 0 0 auto;
  background: #eceff1;
  color: #37474f;
  border-radius: 10px;
  padding: 1px 8px;
  font-size: 11px;
  white-space: nowrap;
}
.urun-metin {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: #607d8b;
  text-align: left;
}

.urun-ipucu {
  max-width: 440px;
}
.urun-ipucu-baslik {
  font-weight: 600;
  margin-bottom: 4px;
}
.urun-ipucu-liste {
  white-space: normal;
  word-break: break-word;
  line-height: 1.5;
  font-size: 12px;
}

.son-islem-hucre {
  max-width: 170px;
}
.son-islem-kutu {
  line-height: 1.25;
}
.son-islem-ad {
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.son-islem-alt {
  font-size: 11px;
  color: #90a4ae;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gecmis-filtre {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 16px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}
.gecmis-filtre-sol {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.aralik-aktif {
  background: #1976d2 !important;
  color: #fff !important;
}
.gecmis-tarih-alan {
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
}
.gecmis-tarih {
  border: 1px solid #cfd8dc;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 12px;
  background: #fff;
}
.gecmis-arama-alan {
  display: inline-flex;
  align-items: center;
  margin-left: 14px;
}
.gecmis-arama {
  border: 1px solid #cfd8dc;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 12px;
  background: #fff;
  width: 150px;
}
.gecmis-sayac {
  font-size: 12px;
  color: #546e7a;
}

.gecmis-satir {
  border-left: 4px solid #9e9e9e;
  padding: 10px 0 10px 14px;
  margin-bottom: 10px;
  background: #fafafa;
  border-radius: 0 4px 4px 0;
}
.gecmis-satir:last-child {
  margin-bottom: 0;
}
</style>
